<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";



/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Deposit Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Customer Deposit Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customers Deposit Details",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "customer.name",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "mode",
          sortable: true,
          label: "MODE",
        },

        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "added_on",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      // edit unit
      editdata: {
        date: "",
        amount: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },

      dateError:"",
      customerError:""
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("customers", ["SaveStatus","CustomerDeposits"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.CustomerDeposits ? this.CustomerDeposits.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerDeposits ? this.CustomerDeposits.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCustomerDeposits: "customers/fetchCustomerDepositsDetails",
      EditCustomerDeposit: "customers/editCustomerDeposit",
      DeleteCustomerDeposit: "customers/deleteCustomerDeposit",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },


    resetEdit() {
      this.editdata.date = "";
      this.editdata.amount = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.customerError = "";
      this.amountError = "";
      this.dateError = "";
      this.modeError = "";
      this.nameError = "";
      this.contactError = "";
    },
    showEditModal(val) {
      this.editdata.amount = val.item.amount;
      this.editdata.date = val.item.date;
      this.editdata.id = val.item.id;
    },
    editCustomerDeposit(modalId) {
      this.modal_id = modalId;
      if ((this.editdata.amount < 0) || (this.editdata.amount == "")) {
        this.amountError = "Amount should be greater than 0";
        return;
      } else {
        this.amountError = "";
      }
      if (this.editdata.date == "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      this.EditCustomerDeposit(this.editdata);
    },
    validateCustomerEdit(){
      if (this.editdata.name !="" && this.editdata.contact!=''){
        let selCust = this.Customers.filter((item)=>{
          return  (item.phone ==  parseInt(this.editdata.contact)) && (item.id != this.editdata.id) ;
        })
        let custCount =selCust.length;
        if (custCount>0){
          this.customerError="Customer with contact "+this.editdata.contact+"  already Exists";
        }
      }

    },
    showDeleteModal(val) {
      this.deletedata.name = val.item.amount;
      this.deletedata.id = val.item.id;
    },
    deleteCustomerDeposit(modalId) {
      this.modal_id = modalId;
      this.DeleteCustomerDeposit(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchCustomerDeposits(atob(this.$route.params.id));

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9"></div>
              <div class="col-md-3" align="right">
                  <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="CustomerDeposits?CustomerDeposits:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(amount)="data">
                  {{ (data.item.amount).toLocaleString() }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                      v-if="MyUserPerm.edit_customer_deposits == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-product-modal
                      class="m-2"
                      @click="showEditModal(data)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      v-if="MyUserPerm.delete_customer_deposits == 1"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-product-modal
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>
            </div>
            <Loader  v-if="!CustomerDeposits"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     edit modal starts-->
    <b-modal id="edit-product-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Customer deposit of {{ editdata.amount }}</template>
      <div class="form-group mb-3">
        <label>Date <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="date"
              class="form-control"
              @input="resetError()"
              v-model="editdata.date"
          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Amount <span class="text-danger">*</span></label>
        <input
            type="number"
            class="form-control"
            @input="resetError()"
            v-model="editdata.amount"
        />

        <div class="text-danger" v-if="customerError">
          <em>{{ customerError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editCustomerDeposit('edit-product-modal')"
        > <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
        header-bg-variant="danger"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="danger"
        footer-text-variant="danger"
        id="delete-product-modal"
        hide-footer
        @hidden="resetDelete"
    >
      <template #modal-title> Delete Customer deposit of {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteCustomerDeposit('delete-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
